import BaseModel from '../core/BaseModel'
export default class ProductSerialNumberInfoLogChangedViewModel extends BaseModel {
    constructor() {
        super({ 
                name: "product_serial_number_info_log_changed_view",
                tableName: 'core_product_serial_number_info_log_changed'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            modified_date: { 
                name: 'modified_date', 
                type: "Date", 
                label: 'Thời gian cập nhật',
                class: 'center',
            },
            

            full_name: { 
                name: 'full_name', 
                type: "String", 
                label: 'Người cập nhật',
                class: 'center',
                computed: (data) => {
                    data.full_name = (data.users !== undefined && data.users !== null ) ? data.users.full_name : '' 
                }
            },
            organization: { 
                name: 'organization', 
                label: 'Đơn vị cập nhật',
                class: 'center',
                type: "String",
                computed: (data) => {
                    data.organization = (data.organizations !== undefined && data.organizations != null) ? data.organizations.name : '' 
                }
            },
            message: { 
                name: 'message', 
                label: 'Nội dung cập nhật'
            },
            verify_status: { 
                name: 'verify_status', 
                type: "Selection",
                label: 'Trạng thái nghiệm thu',
                dataType: 'Label', 
                filter: { type: 'select', visible: false, optionLabel: 'label', optionKey: 'value', match: 'equals'},
                options: [{ value: 1, label: 'Đã nghiệm thu'}, { value: 0, label: 'Chờ nghiệm thu'}, { value: 2, label: 'Không nghiệm thu'}],
                computed: (data) => {
                    if (data.new_value != null) {
                        var json = JSON.parse(data.new_value);
                        data.verify_status  = json.verify_status;
                    }
                }
            },
            warranty_status: { 
                name: 'warranty_status', 
                type: "Selection",
                label: 'Trạng thái bảo hành',
                dataType: 'Label', 
                class: 'center',
                width: 10,
                options: [{ value: 1, label: 'Đã kích hoạt', style: 'color: #00CC00; font-weight: 500;'}, { value: 0, label: 'Chưa kích hoạt', style: 'color: #FF6600; font-weight: 500;'}, { value: 2, label: 'Chờ kích hoạt', style: 'color: #990099; font-weight: 500;'}, { value: 3, label: 'Đã kích hoạt', style: 'color: #00CC00; font-weight: 500;'}, { value: 4, label: 'Hết bảo hành', style: 'color: #0000CC; font-weight: 500;'}, {value: 6, label: 'Sản phẩm huỷ', style: 'color: #000; font-weight: 500;'}],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' },
                computed: (data) => {
                    if (data.new_value != null) {
                        var json = JSON.parse(data.new_value);
                        data.warranty_status  = (json.warranty_status == 5 ? 0 : json.warranty_status);
                    }
                }
            },
            author_id: {
                refs: 'organizations { name }  users { full_name }',
                display: false
            }
        },)
    }

}